/**
 * @file The image service
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { UploadService } from './upload.service';
import { AlertsService } from '../core/alerts.service';
/**
 * Class for the image service
 */
var ImageService = /** @class */ (function (_super) {
    tslib_1.__extends(ImageService, _super);
    /**
     * Constructs a ImageService.
     * @param alertsService Service for giving user feedback
     */
    function ImageService(alertsService) {
        var _this = _super.call(this, alertsService) || this;
        /** The allowed mime types */
        _this.allowedMimeTypes = [
            'image/png',
            'image/jpeg',
            'image/gif'
        ];
        /** The available files (only for demo!) */
        _this.uploads = [
            {
                id: 1,
                filename: '15922700.png',
                url: require('./assets/images/resource-300x300.png'),
                type: 'image/png',
                size: 2300,
                created: new Date(),
                user: 'Piet Klaassen'
            }
        ];
        /** The fallback profile picture image */
        _this.fallbackImage = require('./assets/images/resource-300x300.png');
        return _this;
    }
    /**
     * The custom upload handler
     * @param item The entity the upload belongs to
     * @param filename The file name
     * @param data The file data
     */
    ImageService.prototype.startUpload = function (item, fileName, data) {
        console.log('handleUpload: image');
        if (data) {
            // Add upload logic
            // Give user information about the result
            this.alertsService.createAlert('success', 'APP.INPUTS.FILE_SUCCESSFULLY_UPLOADED');
        }
    };
    return ImageService;
}(UploadService));
export { ImageService };
